export default __webpack_public_path__ + "static/media/GIF_2.d88a04eb.mp4";